import { useSelector } from "react-redux";

import {
  getUserAccountType,
  getUserId,
  isSignedIn
} from "seneca-common/features/user/state";
import { useRedirectOnCondition } from "seneca-common/utils/hooks/routing";

import { linkToCompleteAccountType } from "features/sign-up/complete-account/links";

export default function useRedirectToSelectAccountType() {
  const userId = useSelector(getUserId);
  const signedIn = useSelector(isSignedIn);
  const accountType = useSelector(getUserAccountType);
  const onSignUpPath = window.location.pathname.includes("/sign-up");

  const shouldRedirect = userId && signedIn && !accountType && !onSignUpPath;

  useRedirectOnCondition(shouldRedirect, linkToCompleteAccountType());
}
